import {
  Container,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          alignItems="flex-start"
        >
          {/* LEFT CONTENT */}
          <Grid item xs={12} md={5}>
            <Typography variant="h4" sx={{ mb: 1 }}>
              Let's talk about your problem.
            </Typography>

            <Typography variant="body1" color="grey.400" sx={{ mb: 3 }}>
              info@nerdshub.co.in
            </Typography>

            {/* US HEADQUARTERS */}
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
              US Head Quarters
            </Typography>
            <Typography variant="body2" color="grey.400" sx={{ mb: 2 }}>
              4595 Chabot Drive, Suite 200<br />
              Pleasanton,<br />
              California – 94588
            </Typography>

            {/* INDIAN HEADQUARTERS */}
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
              Indian Head Quarters
            </Typography>
            <Typography variant="body2" color="grey.400" sx={{ mb: 1 }}>
              Nerds Hub (E) Pvt Ltd<br />
              No.2/88, 1st Floor, Saravana Matrix Tower LLP,<br />
              OMR, Seevaram, Perungudi, Chennai – 600 096
            </Typography>

            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Tel: +91 44 6112 6190
            </Typography>
          </Grid>

          {/* RIGHT FORM */}
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ContactForm />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
